module.exports = __webpack_public_path__ + "static/img/so2_5.fd6e43a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so2_5.jpg
// module id = Fw1d
// module chunks = 11